<template>
  <div>
    <CRow>
      <CCol cols="12" xl="12" lg="12" md="12" sm="12" class="pb-0">        
        <div class="smart_filter_presets">
          <CRow>
            <CCol v-if="smartFilterPresets.length > 0" cols="4" lg="4" class="pt-0">
              <CButton color="primary" @click="!showPresets ? showPresets = true : showPresets = false;">
                <i class="fas fa-filter mr-1"/>
                <span>{{$t('core.Load_smart_filter_preset')}}</span>
              </CButton>
            </CCol>
            <CCol cols="8" lg="8" :class="{'pt-0' : smartFilterPresets.length > 0, 'pt-0 pb-0' : smartFilter.filters.length > 0, 'p-0' : (!smartFilter.smart_filter_preset_id_external && !showPresetSaveButton)}">
              <div v-if="!smartFilter.smart_filter_preset_id_external" 
                   class="d-flex align-items-center" 
                   :class="{'justify-content-start' : smartFilterPresets.length === 0, 
                            'justify-content-end' : smartFilterPresets.length > 0,
                            'mb-2_5' : showPresetSaveButton}">

                <CButton v-if="showPresetSaveButton" color="primary" @click="openPresetModal('save');">
                  <i class="fas fa-plus mr-1"/>
                  <span>{{$t('Save')}}</span>
                </CButton>
              </div>
              <div v-if="smartFilter.smart_filter_preset_id_external" class="mb-2_5 d-flex align-items-center justify-content-end">
                <div class="mr-1">
                  <span><b>{{$t('core.Active_preset')}}:</b> {{smartFilter.title}}</span>
                </div>

                <CButton v-if="showPresetSaveButton && smartFilter.editable" color="primary" @click="openPresetModal('update');" class="ml-1_5 mr-0">
                  <i class="fas fa-check mr-1"/>
                  <span>{{$t('Update')}}</span>
                </CButton>
                <CButton v-if="showPresetSaveAsButton" color="primary" @click="openPresetModal('save_as');" class="ml-1_5 mr-0">
                  <i class="fas fa-plus mr-1"/>
                  <span>{{$t('Save_as')}}</span>
                </CButton>
                <CButton v-if="smartFilter.editable" color="primary" @click="openPresetModal('delete');" class="ml-1_5 mr-0">
                  <i class="fas fa-times mr-1"/>
                  <span>{{$t('Delete')}}</span>
                </CButton>              
              </div>
            </CCol>
          </CRow>
          
          <transition name="slide-big">
            <div v-if="showPresets">
              <CRow>
                <CCol cols="12" lg="12" class="pt-0 pb-0">
                  <span>{{$t('core.Pick_smart_filter_preset')}}</span>
                </CCol>
              </CRow>
              <CRow class="tile-container pt-0">
                <CCol cols="3" lg="3" class="p-0">
                  <navigationCard @click.native="showPresets = false;" path="" :cardTitle="$t('core.Current_smart_filter')" :cardDescription="$t('core.Keep_using_current_smart_filter')" :cardIcon="null"/>
                </CCol>                                     
                <CCol v-for="preset in smartFilterPresets" v-bind:key="preset.smart_filter_preset_id_external" cols="3" lg="3" class="p-0">
                  <navigationCard @click.native="getSmartFilterPresetDetails(preset.smart_filter_preset_id_external)" path="" :cardTitle="preset.title" :cardDescription="preset.description" :cardIcon="null"/>
                </CCol>
              </CRow>
            </div>
          </transition>       
        </div>
        
        <div class="insights_filters">
          <CRow v-for="(filter, index) in smartFilter.filters" v-bind:key="index">
            <CCol cols="12" lg="12" class="pt-0 pb-0">
              <div class="mb-2_5 d-flex filters">
                <div>
                  <multiselect class="data_table open_absolute"
                              v-model="filter.type" 
                              :options="groupFilterTypes" 
                              :multiple="false"                
                              :placeholder="$t('common.Select_filter_type')" 
                              :selectLabel="$t('common.Add_filter_type')" 
                              :selectedLabel="$t('Added')"
                              :deselectLabel="$t('common.Remove_filter_type')"
                              track-by="type_tag" 
                              label="type_name"
                              :custom-label="customFilterTypeLabel"
                              :disabled="filter.type !== null && filter.type !== undefined"
                              @input="setupTypeFilter(filter.type.type_tag, index);">
                    <span slot="noResult">{{ $t('common.no_types_found') }}</span>
                    <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                  </multiselect>
                </div>
  
                <div v-if="filter.type" class="ml-2" v-bind:class="{'mr-2' : filter.condition && !conditionsWithoutValue.includes(filter.condition.condition_tag)}">
                  <multiselect class="data_table open_absolute"
                              v-model="filter.condition" 
                              :options="typeFilterConditions" 
                              :multiple="false"                
                              :placeholder="$t('common.Select_filter_condition')" 
                              :selectLabel="$t('common.Add_filter_condition')" 
                              :selectedLabel="$t('Added')"
                              :deselectLabel="$t('common.Remove_filter_condition')"
                              track-by="condition_tag" 
                              label="condition_name"
                              :custom-label="customFilterConditionLabel"
                              :disabled="filter.condition !== null && filter.condition !== undefined"
                              @input="filter.condition && conditionsWithoutValue.includes(filter.condition.condition_tag) ? emitSmartFiltersUpdate() : null;">
                    <span slot="noResult">{{ $t('common.no_conditions_found') }}</span>
                    <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                  </multiselect>
                </div>
  
                <div v-if="filter.type && filter.condition && !conditionsWithoutValue.includes(filter.condition.condition_tag)">
                  <div v-if="filter.type.type_tag == 'department'">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="groupFilterDepartments" 
                                :multiple="false"                
                                :placeholder="$t('common.Select_department')"
                                :selectLabel="$t('common.Add_department')" 
                                :selectedLabel="$t('Added')"
                                :deselectLabel="$t('common.Remove_department')"
                                track-by="department_id" 
                                label="department_name"
                                @search-change="asyncFindDepartment"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.no_departments_found') }}</span>
                      <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                    </multiselect>
                  </div>
                  <div v-if="filter.type.type_tag == 'team'">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="groupFilterTeams" 
                                :multiple="false"                
                                :placeholder="$t('common.Select_team')" 
                                :selectLabel="$t('common.Add_team')" 
                                :selectedLabel="$t('Added')"
                                :deselectLabel="$t('common.Remove_team')"
                                track-by="team_id" 
                                label="team_name"
                                @search-change="asyncFindTeam"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.no_teams_found') }}</span>
                      <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                    </multiselect>
                  </div>
                  <div v-if="filter.type.type_tag == 'user'">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="groupFilterUsers" 
                                :multiple="false"                
                                :placeholder="$t('common.Select_user')" 
                                :selectLabel="$t('common.Add_user')" 
                                :selectedLabel="$t('Added')"
                                :deselectLabel="$t('common.Remove_user')"
                                track-by="user_id_external" 
                                label="label"                        
                                @search-change="asyncFindUser"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.no_users_found') }}</span>
                      <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                    </multiselect>  
                  </div>
                  <div v-if="filter.type.type_tag == 'department_manager'">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="groupFilterDepartmentManagers" 
                                :multiple="false"                
                                :placeholder="$t('common.Set_manager')" 
                                :selectLabel="$t('common.Select_manager')" 
                                :selectedLabel="$t('Selected')"
                                :deselectLabel="$t('common.Deselect_manager')"
                                track-by="user_id_external" 
                                label="label"                        
                                @search-change="asyncFindDepartmentManager"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.No_managers_found') }}</span>
                      <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                    </multiselect>
                  </div>                               
                  <div v-if="filter.type.type_tag == 'team_manager'">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="groupFilterTeamManagers" 
                                :multiple="false"                
                                :placeholder="$t('common.Set_employee')" 
                                :selectLabel="$t('common.Select_employee')" 
                                :selectedLabel="$t('Selected')"
                                :deselectLabel="$t('common.Deselect_employee')"
                                track-by="user_id_external" 
                                label="label"                        
                                @search-change="asyncFindTeamManager"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.no_users_found') }}</span>
                      <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                    </multiselect>
                  </div>
                  <div v-if="filter.type.type_tag == 'target_group'">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="groupFilterTargetGroups" 
                                :multiple="false"                
                                :placeholder="$t('common.Select_group')" 
                                :selectLabel="$t('common.Add_group')" 
                                :selectedLabel="$t('Added')"
                                :deselectLabel="$t('common.Remove_group')"
                                track-by="group_id" 
                                label="title"
                                @search-change="asyncFindTargetGroup"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.no_groups_found') }}</span>
                      <span slot="noOptions">{{ $t('common.start_typing_to_search') }}</span>
                    </multiselect>  
                  </div>
                  <div v-if="['date_started', 'date_left'].includes(filter.type.type_tag)">
                    <multiselect class="data_table open_absolute"
                                v-model="filter.value" 
                                :options="typeFilterValues" 
                                :multiple="false"                
                                :placeholder="$t('common.Select_filter_value')" 
                                :selectLabel="$t('common.Add_filter_value')" 
                                :selectedLabel="$t('Added')"
                                :deselectLabel="$t('common.Remove_filter_value')"
                                track-by="type_value_tag" 
                                label="type_value_name"
                                :custom-label="customFilterTypeValueLabel"
                                @input="emitSmartFiltersUpdate();">
                      <span slot="noResult">{{ $t('common.no_values_found') }}</span>
                    </multiselect>                        
                  </div>
                  <div v-if="userAttributes.includes(filter.type.type_tag)">
                    <CInput v-debounce:1s="emitSmartFiltersUpdate"
                            type="text" 
                            class="attribute mb-0"
                            v-model="filter.value">
                    </CInput>
                  </div>                   
                </div>
  
                <CButton class="ml-2 mr-0 d-inline-block" color="primary" @click="removeFilterOption(index);">
                  <i class="fas fa-times"/>
                </CButton>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol cols="12" lg="12" class="pt-0 pb-0">
              <CButton v-if="!smartFilter.smart_filter_preset_id_external || (smartFilter.smart_filter_preset_id_external && smartFilter.editable)" color="primary" @click="addFilterOption();" class="mr-1_5">
                <i class="fas fa-plus mr-1"/>
                <span>{{$t('common.Add_filter')}}</span>
              </CButton>
              <CButton v-if="smartFilter.smart_filter_preset_id_external || smartFilter.filters.length > 0" color="primary" @click="resetSmartFilter();">
                <i class="fas fa-undo mr-1"/>
                <span>{{$t('core.Reset_filter')}}</span>
              </CButton>              
            </CCol>
          </CRow>           
        </div>
      </CCol>
    </CRow>
    
    <b-modal :can-cancel="['x']" :active.sync="presetModal" :width="960" scroll="keep">
      <CCard class="mb-0">
        <CCardHeader class="pb-0">
          <span v-if="presetModalType === 'save'">{{$t('core.Save_smart_filter_preset')}}</span>
          <span v-if="presetModalType === 'update'">{{$t('core.Update_smart_filter_preset')}}</span>
          <span v-if="presetModalType === 'save_as'">{{$t('core.Save_smart_filter_preset_as')}}</span>
          <span v-if="presetModalType === 'delete'">{{$t('core.Delete_smart_filter_preset')}}</span>
        </CCardHeader>
        <CCardBody>
          <div v-if="['save', 'save_as', 'update'].includes(presetModalType)">
            <CRow>
              <CCol cols="12" lg="12" class="pt-0">
                <CInput @input="countdown()" :maxlength="maxCount.title" type="text" :label="$t('common.Title')" class="mb-0" v-model="smartFilter.title" required was-validated/>
                <p class="countdown mt-1 mb-0" v-if="remainingCount.title > 0">{{remainingCount.title}} {{ $t('common.characters_remaining') }}</p>
              </CCol>
            </CRow>
            <CRow>
              <CCol cols="12" lg="12" class="pt-0 pb-0">
                <CTextarea @input="countdown()" :maxlength="maxCount.description" :label="$t('common.Description')" rows="3" class="mb-0" v-model="smartFilter.description"/>
                <p class="countdown mt-1 mb-0" v-if="remainingCount.description > 0">{{remainingCount.description}} {{ $t('common.characters_remaining') }}</p>
              </CCol>
            </CRow>
          </div>
          <div v-if="['delete'].includes(presetModalType)">
            <CRow>
              <CCol cols="12" lg="12" class="pt-0 pb-0">
                <span>{{$t('core.Are_you_sure_to_delete_smart_filter_preset', { preset_title : smartFilter.title})}}</span>
              </CCol>
            </CRow>            
          </div>
        </CCardBody>
        <CCardFooter>
          <CButton v-if="['save', 'save_as'].includes(presetModalType)" color="primary" @click="saveSmartFilterPreset();"><i class="fas fa-check mr-1"/>{{$t('Save')}}</CButton>
          <CButton v-if="['update'].includes(presetModalType)" color="primary" @click="updateSmartFilterPreset();"><i class="fas fa-check mr-1"/>{{$t('Save')}}</CButton>
          <CButton v-if="['delete'].includes(presetModalType)" color="primary" @click="deleteSmartFilterPreset();"><i class="fas fa-trash mr-1"/>{{$t('Delete')}}</CButton>
          <CButton color="secondary" @click="presetModal = false"><i class="fas fa-times mr-1"/>{{ $t('cancel') }}</CButton>
        </CCardFooter>
      </CCard>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect';

import navigationCard from '@/components/common/navigationCard';

export default {
  name: 'SmartFilters',
  props: ['parent'],
  components: {
    Multiselect,
    navigationCard
  },  
  data() {
    return {
      smartFilter: {
        smart_filter_preset_id_external: null,
        title: null,
        description: null,
        filters: [],
        preset_owner: null,
        preset_owner_id_external: null
      },
      smartFilterPresets: [],
      showPresets: false,
      showPresetSaveButton: false,
      showPresetSaveAsButton: false,
      showPresetUpdateButton: false,
      presetModal: false,
      presetModalType: 'save',
      groupFilterTypes: [],
      groupFilterConditions: [],
      typeFilterConditions: [],
      groupFilterValues: [],
      groupFilterTargetGroups: [],      
      groupFilterUsers: [],
      groupFilterDepartmentManagers: [],
      groupFilterTeamManagers: [],      
      groupFilterDepartments: [],
      groupFilterTeams: [],
      typeFilterValues: [],
      userAttributes: ['hours_on_contract', 'myers_briggs', 'disc', 'office_based', 'division', 'language', 'persona_1', 'persona_2', 'persona_3', 'work_location', 'user_function', 'years_of_service', 'days_of_service'],
      conditionsWithoutValue: ['is_not_set', 'is_today'],
      maxCount: {
        title: 50,
        description: 250
      },
      remainingCount: {
        title: 50,
        description: 250
      },      
    }
  },
  methods: {    
    resetSmartFilter() {
      // Reset the smart filter
      this.smartFilter = {
        smart_filter_preset_id_external: null,
        title: null,
        description: null,
        filters: []
      }
      // Update the showPresetSaveButton value
      this.showPresetSaveButton = false;
      // Emit the smart filters updated event
      this.$bus.$emit(this.parent + '_smart_filters_updated', this.smartFilter.filters);
    },
    openPresetModal(type) {
      this.presetModalType = type;
      this.presetModal = true;
      this.countdown();
    },
    emitSmartFiltersUpdate() {
      let _this = this;
      // Set smartFilters variable with only valid filters
      let smartFilters = this.smartFilter.filters.filter(function (el) {
        return el.type && 
               el.condition && (
                (_this.conditionsWithoutValue.includes(el.condition.condition_tag) === false && el.value) || 
                (_this.conditionsWithoutValue.includes(el.condition.condition_tag) === true)
               );
      });
      
      // Emit the smart_filters_updated event
      this.$bus.$emit(this.parent + '_smart_filters_updated', smartFilters);

      // Show/hide the smart filter preset save button
      if(this.smartFilter.filters.length > 0) {
        this.showPresetSaveButton = true;
        this.showPresetSaveAsButton = true;
      } else {
        this.showPresetSaveButton = false;
        this.showPresetSaveAsButton = false;
        this.resetSmartFilter();
      }
    },
    getSmartFilterPresets() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/smart-filters/presets')
      .then(res => {
        this.smartFilterPresets = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getSmartFilterPresetDetails(smartFilterPresetIdExternal) {
      // Hide the presets
      this.showPresets = false;
      // Get the preset details
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/smart-filters/preset/' + smartFilterPresetIdExternal)
      .then(res => {
        this.smartFilter = res.data.data;
        // Emit the smart filters updated event
        this.emitSmartFiltersUpdate();
      })
      .catch(err => {
        console.error(err); 
      });      
    },
    saveSmartFilterPreset() {
      let params = {};
      params.presetData = this.smartFilter;

      axios.post(process.env.VUE_APP_API_URL + '/v1/core/smart-filters/preset', params)
      .then(res => {
        this.$buefy.toast.open({ message: this.$t('core.Smart_filter_preset_added'), type: 'is-success', duration: 2000 });        
        // Update the smart filter preset details
        this.getSmartFilterPresetDetails(res.data.data.smart_filter_preset_id_external);        
        // Update the smart filter presets
        this.getSmartFilterPresets();
        // Close the modal
        this.presetModal = false;
        this.presetModalType = null;
      })
      .catch(err => {
        console.error(err); 
      });      
    },
    updateSmartFilterPreset() {
      let params = {};
      params.presetData = this.smartFilter;

      axios.put(process.env.VUE_APP_API_URL + '/v1/core/smart-filters/preset/' + this.smartFilter.smart_filter_preset_id_external, params)
      .then(res => {
        this.$buefy.toast.open({ message: this.$t('core.Smart_filter_preset_updated'), type: 'is-success', duration: 2000 });
        // Update the smart filter preset details
        this.getSmartFilterPresetDetails(this.smartFilter.smart_filter_preset_id_external);
        // Update the smart filter presets
        this.getSmartFilterPresets();
        // Close the modal
        this.presetModal = false;
        this.presetModalType = null;        
      })
      .catch(err => {
        console.error(err); 
      }); 
    },
    deleteSmartFilterPreset() {
      // Get the preset details
      axios.delete(process.env.VUE_APP_API_URL + '/v1/core/smart-filters/preset/' + this.smartFilter.smart_filter_preset_id_external)
      .then(res => {
        // Close the modal
        this.presetModal = false;
        this.presetModalType = null;
        // Update the smart filter presets
        this.getSmartFilterPresets();             
        // Reset the smart filter
        this.smartFilter.smart_filter_preset_id_external = null;
        this.smartFilter.title = null;
        this.smartFilter.description = null;
        this.smartFilter.filters = [];
        // Emit the smart filters updated event
        this.emitSmartFiltersUpdate();                
      })
      .catch(err => {
        console.error(err); 
      });      
    },
    getGroupFilterTypes() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/targetgroups/filters/types')
      .then(res => {
        this.groupFilterTypes = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getGroupFilterConditions() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/targetgroups/filters/conditions')
      .then(res => {
        this.groupFilterConditions = res.data.data;
        // Set the typeFilterConditions array
        this.typeFilterConditions = this.groupFilterConditions;        
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getTypeFilterConditions(filterTypeTag, filterIndex) {
      // Reset the typeFilterConditions array
      this.typeFilterConditions = this.groupFilterConditions;
      // Filter the typeFilterConditions based on the filter type tag
      this.typeFilterConditions = this.typeFilterConditions.filter( i => i.available_for_filter_type_tags.includes(filterTypeTag));
      // Auto set the condition if the filter type has only one available
      if(this.typeFilterConditions.length === 1) {
        this.smartFilter.filters[filterIndex].condition = this.typeFilterConditions[0];      

        if(this.conditionsWithoutValue.includes(this.smartFilter.filters[filterIndex].condition.condition_tag)) {
          this.emitSmartFiltersUpdate();
        }
      }      
    },   
    getGroupFilterTypeValues() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/targetgroups/filters/types/values')
      .then(res => {
        this.groupFilterValues = res.data.data;
        // Set the typeFilterValues array
        this.typeFilterValues = this.groupFilterValues;        
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getTypeFilterValues(filterTypeTag) {
      // Reset the typeFilterValues array
      this.typeFilterValues = this.groupFilterValues;
      // Filter the typeFilterValues based on the filter type tag
      this.typeFilterValues = this.typeFilterValues.filter( i => i.available_for_filter_type_tags.includes(filterTypeTag));
    },
    setupTypeFilter(filterTypeTag, filterIndex) {
      // Get the filter type conditions
      this.getTypeFilterConditions(filterTypeTag, filterIndex);
      // Get the filter type values
      this.getTypeFilterValues(filterTypeTag);
      // Get the filter values
      if(filterTypeTag === 'department') {
        this.getGroupFilterDepartments();        
      } else if(filterTypeTag === 'team') {
        this.getGroupFilterTeams();        
      } else if(filterTypeTag === 'user') {
        this.getGroupFilterRecipients();        
      } else if(filterTypeTag === 'department_manager') {
        this.getGroupFilterDepartmentManagers();        
      } else if(filterTypeTag === 'team_manager') {
        this.getGroupFilterTeamManagers();        
      } else if(filterTypeTag === 'target_group') {
        this.getGroupFilterTargetGroups();        
      }      
      // Force update
      this.$forceUpdate();
    },    
    customFilterTypeLabel({type_tag}) {
      return this.$t('filter.' + type_tag);
    },    
    customFilterConditionLabel({condition_tag}) {
      return this.$t('condition.' + condition_tag);
    },    
    customFilterTypeValueLabel({type_value_tag}) {
      return this.$t('filter_value.' + type_value_tag);
    },
    addFilterOption() {
      this.smartFilter.filters.push({});
    },
    removeFilterOption(index) {          
      this.smartFilter.filters.splice(index, 1);
      this.emitSmartFiltersUpdate();
    },
    getGroupFilterTargetGroups() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/targetgroups/multiselect')
      .then(res => {
        this.groupFilterTargetGroups = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getGroupFilterRecipients() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/organisation/employees/multiselect')
      .then(res => {
        this.groupFilterRecipients = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getGroupFilterDepartmentManagers() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/organisation/department-managers/multiselect')
      .then(res => {
        this.groupFilterDepartmentManagers = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getGroupFilterTeamManagers() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/organisation/team-managers/multiselect')
      .then(res => {
        this.groupFilterTeamManagers = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },    
    getGroupFilterDepartments() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/organisation/departments/multiselect')
      .then(res => {
        this.groupFilterDepartments = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    getGroupFilterTeams() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/organisation/teams/multiselect')
      .then(res => {
        this.groupFilterTeams = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },    
    asyncFindTargetGroup(query) {
      let searchTerm = query;
      this.groupFilterTargetGroups = [];
      
      if(searchTerm.length >= 2) {      
        axios.get(process.env.VUE_APP_API_URL + '/v1/common/search/targetgroup/' + searchTerm)
        .then(res => {      
          this.groupFilterTargetGroups = res.data.data;
        })
        .catch(err => {
          console.error(err); 
        });
      }   
    },          
    asyncFindUser(query) {
      let searchTerm = query;
      this.groupFilterUsers = [];
      
      if(searchTerm.length >= 2) {      
        axios.get(process.env.VUE_APP_API_URL + '/v1/common/search/users/' + searchTerm)
        .then(res => {      
          this.groupFilterUsers = res.data.data;
        })
        .catch(err => {
          console.error(err); 
        });
      }   
    },
    asyncFindDepartmentManager(query) {
      let searchTerm = query;
      this.groupFilterDepartmentManagers = [];
      
      if(searchTerm.length >= 2) {      
        axios.get(process.env.VUE_APP_API_URL + '/v1/common/search/department-managers/' + searchTerm)
        .then(res => {      
          this.groupFilterDepartmentManagers = res.data.data;
        })
        .catch(err => {
          console.error(err); 
        });
      }   
    },
    asyncFindTeamManager(query) {
      let searchTerm = query;
      this.groupFilterTeamManagers = [];

      if(searchTerm.length >= 2) {
        axios.get(process.env.VUE_APP_API_URL + '/v1/common/search/team-managers/' + searchTerm)
        .then(res => {      
          this.groupFilterTeamManagers = res.data.data;    
        })
        .catch(err => {
          console.error(err); 
        });
      }   
    },
    asyncFindDepartment(query) {
      let searchTerm = query;
      this.groupFilterDepartments = [];
      
      if(searchTerm.length >= 2) {      
        axios.get(process.env.VUE_APP_API_URL + '/v1/common/search/departments/' + searchTerm)
        .then(res => {      
          this.groupFilterDepartments = res.data.data;
        })
        .catch(err => {
          console.error(err); 
        });
      }   
    },
    asyncFindTeam(query) {
      let searchTerm = query;
      this.groupFilterTeams = [];

      if(searchTerm.length >= 2) {
        axios.get(process.env.VUE_APP_API_URL + '/v1/common/search/teams/' + searchTerm)
        .then(res => {      
          this.groupFilterTeams = res.data.data;    
        })
        .catch(err => {
          console.error(err); 
        });
      }   
    },
    countdown() {      
      if(this.smartFilter.title !== null) this.remainingCount.title = this.maxCount.title - this.smartFilter.title.length;
      if(this.smartFilter.description !== null) this.remainingCount.description = this.maxCount.description - this.smartFilter.description.length;
    },    
  },
  mounted: function() {
    // this.$bus.$emit('smart_filters_updated', this.filters);
    
    this.getGroupFilterTypes();
    this.getGroupFilterConditions();
    this.getGroupFilterTypeValues();
    this.getSmartFilterPresets();
  }
}
</script>